// URL formats mirror SHARING_URLS in sharingUrls.ts.
// A visitor shares from their own account.
// WhatsApp uses wa.me/?text= with the post title first, then the URL.
// Facebook uses the public share dialog, with no quote parameter.
// LinkedIn uses share-offsite with url, title, and summary.
// Email uses mailto with the title as the subject and the title plus URL as the body.
// Instagram has no web share endpoint, so the post and story buttons open Instagram
// and the copied text is the post URL (paste it into a post or a story).

const ORIGIN = 'https://carmenlorraine.com';
const INSTAGRAM = 'https://www.instagram.com/';

function blogShareUrl(slug, source) {
  return `${ORIGIN}/blog/${slug}?utm_source=${source}&utm_medium=social&utm_campaign=blog-share`;
}

function blogShareLinks({ slug, title }) {
  const safeTitle = title || '';
  const emailUrl = blogShareUrl(slug, 'email');
  const linkedinUrl = blogShareUrl(slug, 'linkedin');
  return {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${safeTitle}\n${blogShareUrl(slug, 'whatsapp')}`)}`,
    instagramPost: INSTAGRAM,
    instagramPostText: blogShareUrl(slug, 'instagram_post'),
    instagramStory: INSTAGRAM,
    instagramStoryText: blogShareUrl(slug, 'instagram_story'),
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(blogShareUrl(slug, 'facebook'))}`,
    email: `mailto:?subject=${encodeURIComponent(safeTitle)}&body=${encodeURIComponent(`${safeTitle}\n${emailUrl}`)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(linkedinUrl)}&title=${encodeURIComponent(safeTitle)}&summary=${encodeURIComponent(safeTitle)}`,
    copy: blogShareUrl(slug, 'copy'),
  };
}

module.exports = {
  blogShareUrl,
  blogShareLinks,
};
